// buildChannelDeepLinkPath.js — build /channels route with optional query params

import { isAiChannelKey } from 'spaces/utils/aiChannelKeys';
import { buildAiHomePath } from 'spaces/utils/buildAiHomePath';

function cleanString(value) {
  return String(value || '').trim();
}

export function buildChannelDeepLinkPath({
  channelKey,
  baseKey,
  messageKey = '',
  threadRootKey = '',
} = {}) {
  const cleanChannelKey = cleanString(channelKey);
  if (!cleanChannelKey) return '';

  // Ai sessions live on the Home hub.
  if (isAiChannelKey(cleanChannelKey)) {
    return buildAiHomePath({
      channelKey: cleanChannelKey,
      baseKey,
      messageKey,
      threadRootKey,
    });
  }

  const params = new URLSearchParams();
  const cleanBaseKey = cleanString(baseKey);
  const cleanMessageKey = cleanString(messageKey);
  const cleanThreadRootKey = cleanString(threadRootKey);

  if (cleanBaseKey) params.set('baseKey', cleanBaseKey);
  if (cleanThreadRootKey) params.set('threadRootKey', cleanThreadRootKey);
  if (cleanMessageKey) params.set('messageKey', cleanMessageKey);

  const query = params.toString();
  return `/channels/${encodeURIComponent(cleanChannelKey)}${query ? `?${query}` : ''}`;
}

export function resolveAiNavigateTo(result) {
  const navigateTo = result?.navigateTo && typeof result.navigateTo === 'object'
    ? result.navigateTo
    : null;
  if (!navigateTo?.channelKey) return null;

  return {
    channelKey: cleanString(navigateTo.channelKey),
    baseKey: cleanString(navigateTo.baseKey),
    messageKey: cleanString(navigateTo.messageKey),
    path: buildChannelDeepLinkPath({
      channelKey: navigateTo.channelKey,
      baseKey: navigateTo.baseKey,
      messageKey: navigateTo.messageKey,
    }),
  };
}
